import React from "react";

import { Page } from "components/common";

import SettingsProfileContainer from "containers/profile/settings/SettingsProfile.container";

const SettingsPage = () => {
  return (
    <Page title="Impostazioni account">
      <SettingsProfileContainer />
    </Page>
  );
};

export default SettingsPage;
